export function IndustryCard({ icon, label, orange = false }) {
  const tone = orange ? "text-brand-orange" : "text-brand-blue";
  return (
    <div className="group relative overflow-hidden rounded-xl border border-white/25 bg-white/10 px-3 py-6 text-center text-sm font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] backdrop-blur-md transition duration-200 hover:-translate-y-0.5 hover:bg-white/15">
      <span className={`absolute right-3 top-3 h-1.5 w-1.5 rounded-full ${orange ? "bg-brand-orange" : "bg-brand-blue"}`} aria-hidden="true" />
      <span className={`mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/30 bg-white/15 ${tone}`}>
        {icon}
      </span>
      {label}
    </div>
  );
}
